import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchParams: {
    origin: null, // { name, code, address } from /trains/station-codes/
    destination: null, // { name, code, address } from /trains/station-codes/
    date: "", // ISO yyyy-mm-dd, as picked from DatePicker
  },
  isSearching: false, // true while /trains/train-list/ is in flight
  results: null, // { count, data } from /trains/train-list/
};

const trainSearchSlice = createSlice({
  name: "trainSearch",
  initialState,
  reducers: {
    setTrainSearchParams: (state, action) => {
      Object.assign(state.searchParams, action.payload);
    },
    setTrainSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setTrainResults: (state, action) => {
      state.results = action.payload;
    },
    resetTrainSearch: () => initialState,
  },
});

export const {
  setTrainSearchParams,
  setTrainSearching,
  setTrainResults,
  resetTrainSearch,
} = trainSearchSlice.actions;

export default trainSearchSlice.reducer;
